import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { TESTS } from '../../../../constants/applicationConstants';
import {
  DataTableHoc,
  Loader,
  ErrorFallback,
  deleteFilter,
  applyFilter,
  saveFilters,
} from 'smart-react';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../../constants/applicationConstants';
import './Tests.scss';
const BaseTestDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable'),
);
const TestsDataTable = DataTableHoc(BaseTestDataTable);

/**
 * Tests main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Tests component.
 */
const Tests = () => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className='container mx-auto'>
        <React.Suspense fallback={<Loader />}>
          <TestsDataTable
            deleteFilter={deleteFilter}
            applyFilter={applyFilter}
            saveFilters={saveFilters}
            moduleName={TESTS}
            dataColumns={dataColumnsArray}
            gridColumnsList={GridColumnsList}
            dataTableName={TESTS}
            setIsReady={setIsReady}
            isReady={isReady}
            rowLayoutConfigName={`${TESTS}.DataGrid.RowLayout`}
            pageLengthConfigName={`${TESTS}.DataGrid.ItemsPerPage`}
            dataSet={userData}
            setDataSet={setUserData}
            initialSort={{
              field: 'id',
              dir: 'desc',
            }}
            isCardonMobileView={false}
            total={process.env.DefaultLimit}
            defaultRowLayout={process.env.RowLayout}
            rowLayouts={ROW_LAYOUTS}
            pageSizes={PAGE_SIZE}
            isDefaultSlider={true}
            contentSliderTitle={'Test'}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default Tests;
